<script setup lang="ts">
import type { BlockVirtualTour } from '~/types';
import Tourmkr from '~/components/base/Tourmkr.vue';

defineProps<{ data: BlockVirtualTour }>();
</script>

<template>
  <section class="w-full px-4 pb-8 md:px-6" :aria-label="data.title || 'Virtual tour'">
    <Tourmkr :url="data.tour_url" :title="data.title" />
  </section>
</template>
